export { default } from "./ModalScheduleLogistic-component";
